import React from 'react';

import './index.scss';

//material-ui
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

//custom components
import CustomButton from '../../../../../components/basic/CustomButton';
import CustomInput from '../../../../../components/basic/input';

//api
import {api} from '../../../../../functions/api'

//other libraries
import { inject, observer } from 'mobx-react';
import Dropzone from 'react-dropzone'

/**
 * Upload document
 * @param {string} title
 * @param {boolean} open
 */
@inject('internal')
@inject('translate')
@observer
export default class UploadTechDoc extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploading: false,
            file: null,
            extension: null,
            duplicates: [],
        }
    }

    handleDrop = (files) => {
        if(files[0] !== undefined) {
            let fileNameArr = files[0].name.split('.');

            let extension = fileNameArr[fileNameArr.length - 1].toLowerCase()
            if(extension === "xls" || extension === "xlsx" || extension === "pdf" || extension === "doc" || extension === "docx") {
                this.setState({
                    file: files[0],
                    extension: extension,
                })
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FORMAT_IS_NOT_VALID, true)
        }
        
    }

    handleImport = async() => {
        this.setState({uploading: true})
        if(this.state.file === null) {
            this.setState({uploading: false})
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.EMPTY_FILE, true)
            return
        }
        let productId = this.props.routerData.match.params.idProduct;
        let upload_data = await api({
            method: 'post',
            url: `products/${productId}/documents`,
            formData: true,
            formDataDoc: true,
            authorization: this.props.internal.user.access_token,
            params: {
                document: this.state.file
            }
        })

        if(upload_data.success === true || (upload_data.success === false && upload_data.status === 201)) {
            this.setState({uploading: false})
            this.props.internal.setSnackbar(upload_data.data.message, true)
            this.props.onClose(true);
        }
        else{
            this.props.internal.setSnackbar(upload_data.data.message, true)
            this.setState({uploading: false})
        }
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={() => this.props.onClose(false)}
                
            >
                <DialogContent className={`import-products-dialog` }>
                <DialogTitle className={'title'}>{this.props.title}</DialogTitle>
               
                <Dropzone
                    onDrop={files => this.handleDrop(files)}
                    // disableClick
                    multiple={false}
                    accept={[".xlsx", ".xls", ".docx", ".doc", ".pdf"]}
                    >
                    {({getRootProps, getInputProps, open}) => (
                        <div {...getRootProps()} className={`dropzone ${this.state.file !== null ? "dropped":""}`}>
                        <input {...getInputProps()} />
                            {this.state.file !== null && this.state.file.name?
                                <p>{this.state.file.name}</p>
                                :
                                <p>{this.props.translate.i18n.MODULES.PRODUCTS.UPLOAD_DOCUMENT_PLACE}</p>
                            }
                        </div>
                    )}
                    </Dropzone>
                    {/* <CustomInput
                        ref={ref => (this.document_title = ref)}
                        text={''}
                        id={'document_title'}
                        className={'w-100'}
                        required
                    /> */}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    {this.state.duplicates.length ?
                        null
                        :
                        <CustomButton
                            justText
                            progressBar={this.state.uploading}
                            onClick={this.handleImport}
                            mystyle={'btn-white-bg'}
                            title={this.props.translate.i18n.GLOBAL.BUTTONS.UPLOAD}
                        />
                    }
                </DialogActions>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/products/edit/techDocs/import/index.js